import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Card, LoadingBlock, EmptyState, StatCard } from "@/components/common";
import { StatusBadge } from "@/components/StatusBadge";
import { euro, formatDate, PAYMENT_STATUS_LABELS } from "@/lib/format";
import { BadgeEuro, Wallet, Percent, Info } from "lucide-react";

export default function Pagamenti() {
  const { data, isLoading } = useQuery({ queryKey: ["prof-bookings"], queryFn: async () => (await api.get("/professional/bookings")).data });
  const bookings = (data?.bookings || []).filter((b) => ["pagato", "demo_pagato"].includes(b.payment_status));
  const gross = bookings.reduce((s, b) => s + b.price_cents, 0);
  const fees = bookings.reduce((s, b) => s + (b.platform_fee_cents || 0), 0);
  const net = bookings.reduce((s, b) => s + (b.professional_amount_cents || 0), 0);

  return (
    <DashboardLayout title="Pagamenti">
      <div className="mb-4 flex items-start gap-2 bg-[#FBF0D6] border border-[#D99A00]/40 text-[#8a6400] rounded-xl px-4 py-3 text-sm">
        <Info className="h-4 w-4 mt-0.5 shrink-0" /> Compensi e commissioni sono mostrati in modalità demo. Nessun trasferimento reale viene effettuato in questo prototipo.
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <StatCard icon={BadgeEuro} label="Incasso lordo" value={euro(gross)} tone="dark" testid="pay-gross" />
        <StatCard icon={Percent} label="Commissioni piattaforma" value={euro(fees)} tone="yellow" testid="pay-fees" />
        <StatCard icon={Wallet} label="Compenso netto" value={euro(net)} testid="pay-net" />
      </div>
      {isLoading ? <LoadingBlock /> : bookings.length === 0 ? (
        <EmptyState title="Nessun pagamento" subtitle="I compensi delle prestazioni pagate appariranno qui." />
      ) : (
        <div className="space-y-3">
          {bookings.map((b) => (
            <Card key={b.id} className="flex items-center justify-between">
              <div><p className="font-semibold text-[#102A2A]">{b.service_name}</p><p className="text-sm text-[#5C6B68]">{formatDate(b.scheduled_date)} · {b.recipient_name}</p></div>
              <div className="text-right"><p className="font-bold text-[#087A73]">{euro(b.professional_amount_cents)}</p><StatusBadge status={b.payment_status} label={PAYMENT_STATUS_LABELS[b.payment_status]} /></div>
            </Card>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
